// eslint-disable-next-line no-use-before-define
import React, { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { Modal } from 'react-bootstrap';

type Props = {
  handleUnpauseBeneficiary: (
    event: React.MouseEvent<HTMLButtonElement>
  ) => void;
};

const UnpauseBeneficiaryFooter: FC<Props> = ({ handleUnpauseBeneficiary }) => {
  const { t } = useTranslate();

  return (
    <Modal.Footer>
      <button
        type="button"
        className="btn btn-lg btn-primary"
        onClick={handleUnpauseBeneficiary}
      >
        {t('OkRestart')}
      </button>
    </Modal.Footer>
  );
};

export default UnpauseBeneficiaryFooter;
